import { apiJson } from './client';
import type { TwoFactorMethod } from './client';

/** La double authentification du compte connecté (D39). */

export type TwoFactorMode = 'none' | 'email_or_app' | 'app';

export interface MyTwoFactor {
    readonly mode: TwoFactorMode;
    readonly required: boolean;
    readonly methods: readonly TwoFactorMethod[];
    readonly app: boolean;
    readonly appSince: string | null;
    readonly appPending: boolean;
    readonly email: boolean;
    readonly recoveryCodesLeft: number;
    readonly mustEnroll: boolean;
}

export interface AppSetup {
    readonly secret: string;
    readonly uri: string;
}

export interface WithRecoveryCodes {
    readonly recoveryCodes: readonly string[];
    readonly state: MyTwoFactor;
}

export function myTwoFactor(): Promise<MyTwoFactor> {
    return apiJson('/api/me/two-factor');
}

export function setupApp(): Promise<AppSetup> {
    return apiJson('/api/me/two-factor/app', { method: 'POST', body: '{}' });
}

export function confirmApp(code: string): Promise<WithRecoveryCodes> {
    return apiJson('/api/me/two-factor/app/confirm', { method: 'POST', body: JSON.stringify({ code }) });
}

export function removeApp(code: string): Promise<MyTwoFactor> {
    return apiJson('/api/me/two-factor/app', { method: 'DELETE', body: JSON.stringify({ code }) });
}

export function chooseEmail(enabled: boolean): Promise<MyTwoFactor> {
    return apiJson('/api/me/two-factor/email', { method: 'PUT', body: JSON.stringify({ enabled }) });
}

export function renewRecoveryCodes(code: string): Promise<WithRecoveryCodes> {
    return apiJson('/api/me/two-factor/recovery-codes', { method: 'POST', body: JSON.stringify({ code }) });
}
